// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"d01ac8f5","224":"deba524b","295":"09da7758","781":"284c2a48","872":"9f3e72a7","947":"284c2a48"}[chunkId] + ".chunk.css";
};